import { useCallback, useLayoutEffect, useState } from 'react';

import { Button } from 'antd';
import { useNavigate } from 'react-router';

import type { ISchoolMainData } from '@/api/endpoints/schools';
import { DataSection } from '@/shared/components';
import { ROUTES } from '@/shared/consts';

import { IconSelectLabel } from '../_components/IconSelectLabel/IconSelectLabel';
import { UnpublishSchoolModal } from '../SchoolsCatalogPage/_components/UnpublishSchoolModal/UnpublishSchoolModal';

import styles from './SchoolViewPage.module.scss';

interface IProps {
  schoolData: Omit<ISchoolMainData, 'lms_account_id'> & { lmsAccountName: string };
}

export const ViewCorporateSchoolComponent = ({ schoolData }: IProps) => {
  const [isUnpublishSchoolModalOpened, setIsUnpublishSchoolModalOpened] = useState(false);

  const navigate = useNavigate();

  const { name: schoolName, icon: schoolIcon, lmsAccountName, active: isActive, id: schoolId } = schoolData;

  const goBack = () => {
    navigate(`/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}`);
  };

  useLayoutEffect(() => {
    if (!isActive) {
      navigate(`/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}/${schoolId}/${ROUTES.EDIT}`);
    }
  }, [isActive, schoolId]);

  const openUnpublishSchoolModal = useCallback(() => setIsUnpublishSchoolModalOpened(true), []);
  const closeUnpublishSchoolModal = useCallback(() => setIsUnpublishSchoolModalOpened(false), []);

  return (
    <>
      <DataSection titleText="Название">
        <p className={styles['data-value']}>{schoolName}</p>
      </DataSection>
      <DataSection titleText="Аккаунт школы в LMS">
        <p className={styles['data-value']}>{lmsAccountName}</p>
      </DataSection>
      <DataSection titleText="Иконка школы">
        <IconSelectLabel
          textClassName={styles['data-value']}
          iconType={schoolIcon}
        />
      </DataSection>
      <div className={styles['buttons-wrapper']}>
        <Button
          onClick={goBack}
          type="dashed"
          size="large"
          className={styles.button}
        >
          Назад
        </Button>
        <Button
          type="primary"
          onClick={openUnpublishSchoolModal}
          className={styles.button}
        >
          Снять с публикации
        </Button>
      </div>
      <UnpublishSchoolModal
        isModalOpen={isUnpublishSchoolModalOpened}
        handleCancel={closeUnpublishSchoolModal}
        schoolInfo={{
          id: schoolId,
          name: schoolName,
        }}
      />
    </>
  );
};
